<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container main_bg">
      <i-card-vertical headerTitle="세금계산서 발행 상세" device="web">
        <template v-slot:body>
          <v-layout column>
            <taxInvoice ref="taxInvoice" :seq="params.seq" :params="params" />
          </v-layout>
        </template>
      </i-card-vertical>
      <v-sheet class="iCardRightWrap">
        <i-card-right>
          <template v-slot:customBtn>
            <i-icon-button color="btn_text" :text="'목록으로'" :icon="'back'" :appendDivider="true" @click="btnCancel"></i-icon-button>
            <i-icon-button color="btn_text" :text="'발급보류'" :icon="'print_no'" :appendDivider="true" @click="btnPending"></i-icon-button>
            <i-icon-button color="btn_text" :text="'발급하기'" :icon="'printer'" @click="btnIssue"></i-icon-button>
          </template>
        </i-card-right>
        <i-card-right>
          <template v-slot:customBtn>
            <i-icon-button color="btn_text" :text="'초기화'" :icon="'reset'" @click="btnReset"></i-icon-button>
          </template>
        </i-card-right>
      </v-sheet>
    </v-sheet>
  </v-container>
</template>

<script>
import baseview from '@/views/base/baseview.vue'
import iCardVertical from '@/components/common/iCardVertical.vue'
import taxInvoice from '@/payment/components/taxInvoice.vue' // 세금 계산서 컴포넌트
export default {
  mixins: [baseview],
  name: 'TaxInvoiceManageDetail',
  components: {
    'i-card-vertical': iCardVertical,
    taxInvoice
  },
  props: {},
  data() {
    return {
      params: {}
    }
  },
  watch: {},
  created() {},
  activated() {
    if (this.$route.params.data) {
      if (!this.$route.params.data.__created__) {
        // 상세보기로 이동한 경우
        this.params = this.$route.params.data
        //상세 데이터 조회시 무조건 재조회
        this.$refs.taxInvoice.btnSearch(this.params.seq)
      }
    } else if (this.$route.params.issueParam) {
      // 미발행 메뉴에서 넘어왔을 때
      this.params = this.$route.params.issueParam
    } else {
      const toRouter = {
        name: 'TaxInvoiceManage',
        params: {
          data: { flag: true }
        }
      }
      this.$router.push(toRouter)
    }
  },
  mounted() {},
  methods: {
    btnCancel() {
      this.vToastifyPrompt(this.$t('작성을 중지하고 이전 페이지로 이동하시겠습니까?'), 'info', async current => {
        const toRouter = {
          name: 'TaxInvoiceManage',
          params: {
            data: { flag: true }
          }
        }
        this.$router.push(toRouter)
        return
      })
    },
    btnPending() {
      // 보류하기
      this.$refs.taxInvoice.btnPending()
    },
    btnIssue() {
      // 발급하기
      this.$refs.taxInvoice.btnIssue()
    },
    btnReset() {
      // 초기화
      this.$refs.taxInvoice.btnReset()
    }
  }
}
</script>
